module.exports = __webpack_public_path__ + "assets/scoober-logo-icon-52880f.svg";